<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">NOW WE SHALL BE <br/>ENTIRELY FREE</strong></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// now-we-shall-be_00001.vue?fe775b92